import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ANIMATION_FUNCTION } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { FILTER_CARD_ANIMATION_DURATION } from "../../constants";

const ANIMATION = `${FILTER_CARD_ANIMATION_DURATION}ms ${ANIMATION_FUNCTION}`;

const DISABLED_CARD_OPACITY = 0.5;

export const StyledFilterItemCardExpandContent = styled.div`
    min-height: 0;
`;

export const StyledFilterItemCardExpandWrapper = styled.div<{ isExpanded: boolean }>`
    display: grid;
    grid-template-rows: ${({ isExpanded }) => (isExpanded ? 1 : 0)}fr;
    opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
    transition:
        grid-template-rows ${ANIMATION},
        opacity ${ANIMATION};

    > ${StyledFilterItemCardExpandContent} {
        overflow: ${({ isExpanded }) => (isExpanded ? "visible" : "hidden")};
    }
`;

export const StyledFilterItemCardContentWrapper = styled.div`
    padding-bottom: 16px;
`;

export const StyledFilterItemCardItemWrapper = styled(Stack)<{ $isDisabled?: boolean }>`
    gap: 16px;
    border-radius: 8px;
    background: ${colorsPalettes.bluegrey["100"]};
    opacity: ${({ $isDisabled }) => ($isDisabled ? DISABLED_CARD_OPACITY : 1)};
`;

export const StyledFilterItemCardBodyWrapper = styled(Stack)`
    gap: 16px;
    padding: 0 16px 0 16px;

    & > *:nth-child(1):not(${StyledFilterItemCardExpandWrapper}) {
        margin-top: -2px;
    }
`;

export const StyledFilterItemCardItemHeader = styled(Flex)<{ isExpandable: boolean }>`
    align-items: center;
    gap: 8px;
    padding: 8px 8px 0 16px;
    margin-top: 0;
    margin-bottom: -8px;
    cursor: ${({ isExpandable }) => (isExpandable ? "pointer" : "default")};
`;

export const StyledFilterItemCardItemTitle = styled(Flex)`
    height: 32px;
    gap: 5px;
    align-items: center;
    flex: 1 1 auto;
    min-width: 0;
`;

export const StyledFilterItemCardActions = styled(Flex)`
    justify-content: space-between;
    gap: 2px;
    align-items: center;
    flex-shrink: 0;
`;

export const StyledBorderedFilterCardWrapper = styled.div`
    border: 2px solid ${colorsPalettes.bluegrey[200]};
    border-radius: 8px;

    ${StyledFilterItemCardItemWrapper} {
        background-color: ${colorsPalettes.carbon[0]};
        border-radius: 8px;
    }
`;

export const StyledProminentFilterCardWrapper = styled.div`
    border: 2px solid transparent;
    border-radius: 8px;

    background-image: linear-gradient(225deg, #dceeff 17.87%, #a8caf0 100%);
    background-origin: border-box;

    ${StyledFilterItemCardItemWrapper} {
        border-radius: 6px;
    }
`;
